import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SessionExpiredDialog = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate('/login');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: 'rgba(0, 30, 60, 0.95)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)'
        }
      }}
    >
      <DialogTitle sx={{ 
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <WarningIcon sx={{ color: '#ff9800' }} />
        会话已过期
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            您的登录会话已过期，可能是由于：
          </Alert>
          
          <Typography variant="body1" sx={{ color: '#fff', mb: 2 }}>
            • 在其他设备上登录，当前会话被强制下线
          </Typography>
          
          <Typography variant="body1" sx={{ color: '#fff', mb: 2 }}>
            • 会话时间已超过7天，自动过期
          </Typography>
          
          <Typography variant="body1" sx={{ color: '#fff', mb: 2 }}>
            • 管理员强制下线了您的账户
          </Typography>
          
          <Typography variant="body2" sx={{ color: '#90caf9', mt: 2 }}>
            为了确保账户安全，请重新登录。
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={handleLogin}
          variant="contained"
          sx={{
            bgcolor: '#00ff9f',
            color: '#001e3c',
            '&:hover': {
              bgcolor: '#00cc7f'
            }
          }}
        >
          重新登录
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog; 